<template>
  <div class="px-1">
    <NavigationBreadcrumb
      :items="breadcrumb_items"
      :egressProfileId="egress_profile_id"
      :showMatrix1="true"
      :showMatrix2="true"
      :showMatrix3="true"
      :showMatrix4="true"
      :showStudyPlan="true"
      :showCurricularMesh="true"
    ></NavigationBreadcrumb>
    <h4 class="mt-3 mb-0">
      {{ $getVisibleNames("mesh.egressprofile", false, "Perfil de Egreso") }}
      <AlternativeNameButton
        :table_name="'mesh.egressprofile'"
        :allows_crud="allows_crud"
      ></AlternativeNameButton>
      <template v-if="egressProfile">
        <template v-if="allows_crud">
          <button-edit
            v-if="allows_crud && can_update"
            v-can="'mesh.change_egressprofile'"
            @click="
              $bvModal.show(`modal-edit-egressprofile-${egressProfile.id}`)
            "
            v-b-tooltip.v-secondary.noninteractive="
              `${$t('reusable.common.edit')} ${$getVisibleNames(
                'mesh.egressprofile',
                false,
                'Perfil de Egreso'
              )}`
            "
          ></button-edit>
        </template>
        <b-modal
          :id="`modal-edit-egressprofile-${egressProfile.id}`"
          hide-footer
          :title="`${$t('reusable.common.edit')} ${$getVisibleNames(
            'mesh.egressprofile',
            false,
            'Perfil de Egreso'
          )}`"
          size="xl"
        >
          <EgressProfileForm
            :EgressProfile="egressProfile"
            :career_id="egressProfile.career"
            :show_selected_career="false"
            :show_delete_button="false"
            @updated="
              $bvModal.hide(`modal-edit-egressprofile-${egressProfile.id}`)
            "
          ></EgressProfileForm>
        </b-modal>
      </template>
      <template
        v-if="
          (isClosedEgressProfile && allows_crud) ||
          (isClosedEgressProfile && egressProfile && egressProfile.is_closed)
        "
      >
        <b-button
          class="noprint"
          size="sm"
          variant="none"
          v-b-tooltip.v-secondary.noninteractive="
            `${$t(
              'egressProfile.egressProfileView.changeStateOf'
            )} ${$getVisibleNames(
              'mesh.egressprofile',
              false,
              'Perfil de Egreso'
            )}`
          "
          @click="changeStateEgressProfile()"
        >
          <template v-if="egressProfile && egressProfile.is_closed">
            <b-icon class="btn-actions" icon="lock" scale="1"></b-icon>
          </template>
          <template v-else>
            <b-icon class="btn-actions" icon="unlock" scale="1"></b-icon>
          </template>
        </b-button>
      </template>
      <!-- <EgressProfileLinkage
          :egress_profile_id="egress_profile_id"
          :allows_crud="allows_crud"
        ></EgressProfileLinkage> -->
      <!-- Perfil de Egreso -->
    </h4>
    <div class="d-flex">
      <template>
        <div class="ml-auto mr-0 noprint d-flex">
          <ContainerButtonsDownload
            v-if="showAiGroup"
            :id_button="`col-display-ai-${egress_profile_id}`"
            :tooltip_text="''"
            :text_button="$t('egressProfile.egressProfileView.aiActionsButton')"
            :variant="'none'"
            :custom_class="'btn-ai-custom'"
            class="ml-2"
          >
            <template #icon>
              <img src="@/assets/icon-ai.svg" alt="" class="icon-btn-ai mr-1" />
            </template>
            <template #popover-container-buttons>
              <!-- Solo botones dentro del popover: los modales (reportes y
                   builder) viven en la raíz de la vista, porque el popover
                   destruye su contenido al cerrarse (matando cualquier
                   modal abierto) y su transform atrapa overlays fixed. -->
              <div>
                <b-button
                  v-if="showAiReports && userHasAiComponent"
                  v-b-tooltip.topleft.v-secondary.noninteractive="{
                    title: $t(
                      'egressProfile.egressProfileView.pertinenceButtonTooltip',
                      {
                        entity: $getVisibleNames(
                          'mesh.egressprofile',
                          false,
                          'Perfil de Egreso'
                        ),
                      }
                    ),
                    boundary: 'viewport',
                  }"
                  size="sm"
                  variant="none"
                  class="w-100 text-left btn-ai-custom"
                  @click="openAiReportModal('pertinence_report_modal')"
                >
                  <img
                    src="@/assets/icon-ai.svg"
                    alt=""
                    class="icon-btn-ai mr-1"
                  />
                  {{
                    $t("egressProfile.egressProfileView.pertinenceButtonText", {
                      entity: $getVisibleNames(
                        "mesh.egressprofile",
                        false,
                        "Perfil de Egreso"
                      ),
                    })
                  }}
                </b-button>
                <b-button
                  v-if="showAiReports && userHasAiComponent"
                  v-b-tooltip.topleft.v-secondary.noninteractive="{
                    title: $t(
                      'egressProfile.egressProfileView.pedagogicalButtonTooltip',
                      {
                        entity: $getVisibleNames(
                          'mesh.egressprofile',
                          false,
                          'Perfil de Egreso'
                        ),
                      }
                    ),
                    boundary: 'viewport',
                  }"
                  size="sm"
                  variant="none"
                  class="w-100 mt-1 text-left btn-ai-custom"
                  @click="openAiReportModal('pedagogical_report_modal')"
                >
                  <img
                    src="@/assets/icon-ai.svg"
                    alt=""
                    class="icon-btn-ai mr-1"
                  />
                  {{
                    $t(
                      "egressProfile.egressProfileView.pedagogicalButtonText",
                      {
                        entity: $getVisibleNames(
                          "mesh.egressprofile",
                          false,
                          "Perfil de Egreso"
                        ),
                      }
                    )
                  }}
                </b-button>
                <b-button
                  v-if="showAiQuickCreation"
                  size="sm"
                  variant="none"
                  class="w-100 mt-1 text-left btn-ai-custom"
                  @click="openAiBuilderModal"
                >
                  <img
                    src="@/assets/icon-ai.svg"
                    alt=""
                    class="icon-btn-ai mr-1"
                  />
                  {{ $t("reusable.aiEgressProfileBuilderModal.openButton") }}
                </b-button>
              </div>
            </template>
          </ContainerButtonsDownload>
          <b-button
            class="mb-2 ml-2 noprint"
            size="sm"
            @click="
              redirectToMatterProgramByEgressProfileView(egress_profile_id)
            "
            ><b-icon icon="box-arrow-up-right"></b-icon>
            {{
              $t("egressProfile.egressProfileView.evaluations").toUpperCase()
            }}</b-button
          >
          <ContainerButtonsDownload
            v-if="
              user &&
              ([
                'DIRECTIVOS ACADÉMICOS INSTITUCIONALES',
                'DIRECTIVOS ACADÉMICOS (CAMPUS)',
                'DIRECTIVOS FACULTAD O ESCUELA',
                'DIRECTORES DE CARRERA',
                'DIRECTORES DE CARRERA (CAMPUS)',
                'ADMINISTRATIVOS INSTRUCCIONALES',
              ].some((group) => user.group_names.includes(group)) ||
                user.is_superuser)
            "
            :id_button="`col-display-1-${egress_profile_id}`"
            :tooltip_text="''"
            class="ml-2"
          >
            <template #popover-container-buttons>
              <div>
                <GenericButtonDownload
                  v-if="institution && institution.internal_use_id == 'duoc.cl'"
                  :text_button="
                    $t(
                      'egressProfile.egressProfileView.formatCreationPlanAndMatter'
                    )
                  "
                  :tooltip_text="``"
                  :variant_button="'success'"
                  :click_button="DownloadExcel"
                  :disabled_button="disabled_button_excel"
                  :icon_excel="true"
                  :class="`w-100 text-left`"
                ></GenericButtonDownload>
                <GenericButtonDownload
                  v-if="
                    institution &&
                    (institution.internal_use_id == 'duoc.cl' ||
                      institution.internal_use_id == 'iacc.cl')
                  "
                  :text_button="`${$t(
                    institution && institution.internal_use_id == 'duoc.cl'
                      ? 'egressProfile.egressProfileView.valuationReport'
                      : 'egressProfile.egressProfileView.mattersReport'
                  )} ${$getVisibleNames(
                    'mesh.egressprofilematter',
                    true,
                    'Asignaturas'
                  )}`"
                  :tooltip_text="``"
                  :variant_button="'success'"
                  :click_button="DownloadEgressProfileMatterExcel"
                  :disabled_button="disabled_button_excel"
                  :icon_excel="true"
                  :class="`w-100 mt-1 text-left`"
                ></GenericButtonDownload>
                <GenericButtonDownload
                  :text_button="`${$t(
                    'egressProfile.egressProfileView.outputFormat'
                  )} ${$getVisibleNames(
                    'mesh.egressprofile',
                    false,
                    'Perfil de Egreso'
                  )}`"
                  :tooltip_text="``"
                  :variant_button="'primary'"
                  :click_button="DownloadDocument"
                  :disabled_button="disabled_button_excel"
                  :icon_word="true"
                  :class="`mt-1 w-100 text-left`"
                ></GenericButtonDownload>
                <!-- Decreto de Rectoría: oculto hasta que el reporte esté terminado
                <GenericButtonDownload
                  :text_button="$t('studyPlan.studyPlanView.downloadRectorateDecree')"
                  :tooltip_text="``"
                  :variant_button="'primary'"
                  :click_button="DownloadRectorateDecree"
                  :disabled_button="disabled_button_excel"
                  :icon_word="true"
                  :class="`mt-1 w-100 text-left`"
                ></GenericButtonDownload>
                -->
              </div>
            </template>
          </ContainerButtonsDownload>
          <!-- <b-button
            v-if="
              (institution && institution.internal_use_id == 'duoc.cl') 
            "
            variant="secondary"
            size="sm"
            class="mb-2 ml-3 noprint"
            :disabled="disabled_button_excel"
            @click="DownloadExcel()"
          >
            XLSX Formato Creación Plan y Asignatura
          </b-button> -->
        </div>
      </template>
      <!-- <template
        v-if="
          (institution && institution.internal_use_id == 'duoc.cl') ||
          (institution && institution.internal_use_id == 'unab.cl')
        "
      >
        <div class="noprint">
          <b-button
            variant="secondary"
            size="sm"
            class="mb-2 ml-3 noprint"
            @click="DownloadDocument()"
          >
            Formato de salida de
            {{
              $getVisibleNames(
                "mesh.egressprofile",
                false,
                "Perfil de Egreso"
              ).toLowerCase()
            }}
          </b-button>
        </div>
      </template> -->
    </div>
    <EgressProfile
      :egress_profile_id="egress_profile_id"
      :allows_crud="allows_crud"
      :can_update="can_update"
      :can_delete="can_delete"
    ></EgressProfile>


    <!-- Modales de las acciones IA, fuera del popover (ver botones en
    ContainerButtonsDownload): deben sobrevivir al cierre del popover 
    y renderizarse a nivel de la vista para cubrir la pantalla. -->
    <AiEgressProfileBuilderModal
      v-if="showAiQuickCreation"
      ref="ai_builder_modal"
      :egress_profile_id="egress_profile_id"
    ></AiEgressProfileBuilderModal>
    <template v-if="showAiReports">
      <AiReportModal
        ref="pertinence_report_modal"
        :show_button="false"
        :reportConfig="{
          inteligence_option: 3,
          title: $t('egressProfile.egressProfileView.pertinenceReportTitle', {
            entity: $getVisibleNames(
              'mesh.egressprofile',
              false,
              'Perfil de Egreso'
            ),
          }),
        }"
        :egress_profile_id="egress_profile_id"
        :subtitle="
          career
            ? career.name
            : $getVisibleNames('mesh.egressprofile', false, 'Perfil de Egreso')
        "
      ></AiReportModal>
      <AiReportModal
        ref="pedagogical_report_modal"
        :show_button="false"
        :reportConfig="{
          inteligence_option: 4,
          title: $t('egressProfile.egressProfileView.pedagogicalReportTitle', {
            entity: $getVisibleNames(
              'mesh.egressprofile',
              false,
              'Perfil de Egreso'
            ),
          }),
        }"
        :egress_profile_id="egress_profile_id"
        :subtitle="
          career
            ? career.name
            : $getVisibleNames('mesh.egressprofile', false, 'Perfil de Egreso')
        "
      ></AiReportModal>
    </template>
  </div>
</template>

<script>
// import { URL } from "@/utils/globals";
import { mapGetters } from "vuex";
import * as names from "@/store/names";
import { showLoadingAlert, downloadFileFromResponse } from "@/utils/utils";

export default {
  name: "EgressProfileView",
  components: {
    AiReportModal: () => import("@/components/reusable/AiReportModal"),
    AiEgressProfileBuilderModal: () =>
      import("@/components/reusable/AiEgressProfileBuilderModal"),
    EgressProfile: () => import("./EgressProfile"),
    EgressProfileForm: () =>
      import("@/components/mesh/EgressProfile/EgressProfileForm"),
    AlternativeNameButton: () =>
      import("@/components/reusable/AlternativeNameButton"),
    // EgressProfileLinkage: () => import("./EgressProfileLinkage"),
    ContainerButtonsDownload: () =>
      import("@/components/reusable/Buttons/ContainerButtonsDownload"),
    GenericButtonDownload: () =>
      import("@/components/reusable/Buttons/GenericButtonDownload"),
    NavigationBreadcrumb: () =>
      import("@/components/reusable/NavigationBreadcrumb"),
  },
  data() {
    return {
      egress_profile_id: Number(this.$route.params.egress_profile_id),
      disabled_button_excel: false,
    };
  },
  computed: {
    ...mapGetters({
      institution: "getInstitution",
      egressProfiles: names.EGRESS_PROFILES,
      user: "getUser",
      careers: names.CAREERS,
    }),
    breadcrumb_items() {
      return [
        { text: this.$t("reusable.breadcrumb.home"), to: "/home" },
        {
          text: this.$getVisibleNames("mesh.career", true, "Programas"),
          to: "/careers",
        },
        {
          text: this.$getVisibleNames(
            "mesh.egressprofile",
            false,
            "Perfil de Egreso"
          ),
          dropdownOptions: [
            "showMatrix1",
            "showMatrix2",
            "showMatrix3",
            "showMatrix4",
            "showStudyPlan",
            "showCurricularMesh",
          ],
        },
      ];
    },
    egressProfile() {
      if (!this.egress_profile_id) return [];
      return this.egressProfiles.find((x) => x.id == this.egress_profile_id);
    },
    career() {
      if (!this.egressProfile) return null;
      return this.careers.find((x) => x.id == this.egressProfile.career);
    },
    showAiReports() {
      return (
        this.user &&
        this.institution &&
        this.institution.kl_artificial_intelligence_report &&
        this.egressProfile &&
        !this.egressProfile.is_closed &&
        (this.user.is_superuser ||
          [
            "DIRECTIVOS ACADÉMICOS INSTITUCIONALES",
            "DIRECTIVOS ACADÉMICOS (CAMPUS)",
            "DIRECTIVOS FACULTAD O ESCUELA",
            "DIRECTORES DE CARRERA",
          ].some((group) => this.user.group_names.includes(group)))
      );
    },
    showAiQuickCreation() {
      return (
        this.allows_crud &&
        this.user &&
        this.institution &&
        this.institution.kl_ai_quick_creation &&
        (this.user.user_data == null ||
          (this.user.user_data && this.user.user_data.ai_component)) &&
        this.egressProfile &&
        !this.egressProfile.is_closed &&
        (this.user.is_superuser ||
          [
            "DIRECTIVOS ACADÉMICOS INSTITUCIONALES",
            "DIRECTIVOS ACADÉMICOS (CAMPUS)",
            "DIRECTIVOS FACULTAD O ESCUELA",
            "DIRECTORES DE CARRERA",
          ].some((group) => this.user.group_names.includes(group)))
      );
    },
    showAiGroup() {
      return this.showAiReports || this.showAiQuickCreation;
    },
    userHasAiComponent() {
      // Mismo gating que el botón interno de AiReportModal (que aquí se
      // reemplaza por botones simples dentro del popover).
      return (
        this.user &&
        (this.user.user_data == null ||
          (this.user.user_data && this.user.user_data.ai_component))
      );
    },
    isClosedEgressProfile() {
      if (
        this.user.is_superuser ||
        this.$hasObjectPermission(
          "special.close_egress_profile",
          "special",
          this.egress_profile_id
        )
      ) {
        return true;
      } else return false;
    },
    can_update() {
      if (
        (this.user &&
          [
            "DIRECTIVOS ACADÉMICOS INSTITUCIONALES",
            "DIRECTIVOS ACADÉMICOS (CAMPUS)",
          ].some((group) => this.user.group_names.includes(group))) ||
        this.user.is_superuser
      )
        return true;
      if (
        this.career &&
        this.egress_profile_id &&
        this.user &&
        !["ADMINISTRATIVOS INSTRUCCIONALES"].some((group) =>
          this.user.group_names.includes(group)
        )
      ) {
        return (
          [
            "DIRECTIVOS FACULTAD O ESCUELA",
            "DIRECTORES DE CARRERA",
            "DIRECTORES DE CARRERA (CAMPUS)",
          ].some((group) => this.user.group_names.includes(group)) &&
          (this.$hasObjectPermission(
            "mesh.faculty",
            "change",
            this.career.faculty
          ) ||
            this.$hasObjectPermission(
              "mesh.egressprofile",
              "change",
              this.egress_profile_id
            ))
        );
      }
      return false;
    },
    can_delete() {
      if (
        (this.user &&
          [
            "DIRECTIVOS ACADÉMICOS INSTITUCIONALES",
            "DIRECTIVOS ACADÉMICOS (CAMPUS)",
          ].some((group) => this.user.group_names.includes(group))) ||
        this.user.is_superuser
      )
        return true;
      if (
        this.career &&
        this.egress_profile_id &&
        this.user &&
        !["ADMINISTRATIVOS INSTRUCCIONALES"].some((group) =>
          this.user.group_names.includes(group)
        )
      ) {
        return (
          [
            "DIRECTIVOS FACULTAD O ESCUELA",
            "DIRECTORES DE CARRERA",
            "DIRECTORES DE CARRERA (CAMPUS)",
          ].some((group) => this.user.group_names.includes(group)) &&
          (this.$hasObjectPermission(
            "mesh.faculty",
            "delete",
            this.career.faculty
          ) ||
            this.$hasObjectPermission(
              "mesh.egressprofile",
              "delete",
              this.egress_profile_id
            ))
        );
      }
      return false;
    },
    allows_crud() {
      if (
        this.egressProfile &&
        !this.egressProfile.is_closed &&
        (this.can_update || this.can_delete)
      ) {
        const has_permission = this.$hasPermissions(
          "mesh.change_egressprofile"
        );
        if (has_permission) {
          this.$store.commit(names.MUTATE_VISIBILITY_CRUD, true);
          return has_permission;
        } else {
          return false;
        }
      } else {
        this.$store.commit(names.MUTATE_VISIBILITY_CRUD, false);
        return false;
      }
    },
  },
  methods: {
    openAiBuilderModal() {
      // Se cierra el popover de acciones IA antes de abrir el modal (que
      // vive fuera del popover, en la raíz de la vista).
      this.$root.$emit("bv::hide::popover");
      if (this.$refs.ai_builder_modal) this.$refs.ai_builder_modal.open();
    },
    openAiReportModal(ref_name) {
      // Ídem: si el reporte viviera dentro del popover, el cierre del
      // popover destruiría el componente y su modal se cerraría solo.
      this.$root.$emit("bv::hide::popover");
      if (this.$refs[ref_name]) this.$refs[ref_name].openReport();
    },
    redirectToMatterProgramByEgressProfileView() {
      const url = this.$router.resolve({
        name: "MatterProgramByEgressProfileView",
        params: {
          egress_profile_id: this.egress_profile_id,
        },
      }).href;
      window.open(url, "_blank");
    },
    DownloadRectorateDecree() {
      this.disabled_button_excel = true;
      showLoadingAlert(
        this.$t("egressProfile.egressProfileView.generatingWord"),
        this.$t("reusable.common.pleaseWaitFile")
      );
      this.$restful
        .Post(
          `/teaching/word_report_rectorate_decree/`,
          { egress_profile: this.egress_profile_id },
          { responseType: "blob" }
        )
        .then((response) => {
          this.$swal.close();
          downloadFileFromResponse(
            response,
            "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
            () => {
              this.disabled_button_excel = false;
            },
            () => {
              this.disabled_button_excel = false;
              this.$swal.fire(
                this.$t("reusable.common.error"),
                this.$t("reusable.common.downloadError"),
                "error"
              );
            }
          );
        })
        .catch(() => {
          this.disabled_button_excel = false;
          this.$swal.close();
          this.$swal.fire(
            this.$t("reusable.common.error"),
            this.$t("reusable.common.problemGenerating"),
            "error"
          );
        });
    },
    DownloadDocument() {
      this.disabled_button_excel = true;
      showLoadingAlert(
        this.$t("egressProfile.egressProfileView.generatingWord"),
        this.$t("reusable.common.pleaseWaitFile")
      );
      this.$restful
        .Post(
          `/teaching/word_report_egress_profile_output/`,
          {
            egress_profile: this.egress_profile_id,
          },
          {
            responseType: "blob",
          }
        )
        .then((response) => {
          this.$swal.close();
          downloadFileFromResponse(
            response,
            "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
            () => {
              this.disabled_button_excel = false;
            },
            () => {
              this.disabled_button_excel = false;
              this.$swal.fire(
                this.$t("reusable.common.error"),
                this.$t("reusable.common.downloadError"),
                "error"
              );
            }
          );
        })
        .catch(() => {
          this.disabled_button_excel = false;
          this.$swal.close();
          this.$swal.fire(
            this.$t("reusable.common.error"),
            this.$t("reusable.common.problemGenerating"),
            "error"
          );
        });
    },
    DownloadExcel() {
      this.disabled_button_excel = true;
      showLoadingAlert(
        this.$t("reusable.common.generatingExcel"),
        this.$t("reusable.common.pleaseWaitFile")
      );

      // Usar el wrapper $restful modificado para manejar responseType blob
      this.$restful
        .Post(
          `/mesh/excel_report_duoc_academic_record/`,
          {
            egress_profiles: [this.egress_profile_id],
          },
          {
            responseType: "blob",
          }
        )
        .then((response) => {
          this.$swal.close();

          // Usar la función utilitaria para descargar el blob
          downloadFileFromResponse(
            response,
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            () => {
              // onSuccess callback
              this.disabled_button_excel = false;
            },
            () => {
              // onError callback
              this.disabled_button_excel = false;
              this.$swal.fire(
                this.$t("reusable.common.error"),
                this.$t("reusable.common.downloadError"),
                "error"
              );
            }
          );
        })
        .catch(() => {
          this.disabled_button_excel = false;
          this.$swal.close();
          this.$swal.fire(
            this.$t("reusable.common.error"),
            this.$t("reusable.common.problemGenerating"),
            "error"
          );
        });
    },
    DownloadEgressProfileMatterExcel() {
      this.disabled_button_excel = true;
      showLoadingAlert(
        this.$t("reusable.common.generatingExcel"),
        this.$t("reusable.common.pleaseWaitFile")
      );

      // Usar el wrapper $restful modificado para manejar responseType blob
      this.$restful
        .Post(
          `/teaching/excel_egress_profile_matters_report/`,
          {
            egress_profile: this.egress_profile_id,
          },
          {
            responseType: "blob",
          }
        )
        .then((response) => {
          this.$swal.close();

          // Usar la función utilitaria para descargar el blob
          downloadFileFromResponse(
            response,
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            () => {
              // onSuccess callback
              this.disabled_button_excel = false;
            },
            (error) => {
              // onError callback
              this.disabled_button_excel = false;
              console.error("Error al descargar el archivo:", error);
              this.$swal.fire(
                this.$t("reusable.common.error"),
                this.$t("reusable.common.downloadError"),
                "error"
              );
            }
          );
        })
        .catch((error) => {
          this.disabled_button_excel = false;
          this.$swal.close();
          console.error("Error al generar el archivo:", error);
          this.$swal.fire(
            this.$t("reusable.common.error"),
            this.$t("reusable.common.problemGenerating"),
            "error"
          );
        });
    },
    changeStateEgressProfile() {
      const payload = {
        egress_profile_id: this.egressProfile.id,
        item: {
          is_closed: !this.egressProfile.is_closed,
        },
      };
      this.$store
        .dispatch(names.PATCH_EGRESS_PROFILE, payload)
        .then((response) => {
          if (!response.is_closed)
            this.$store.commit(names.MUTATE_SHOW_INTELLIGENCE_SIDEBAR, true);
          else
            this.$store.commit(names.MUTATE_SHOW_INTELLIGENCE_SIDEBAR, false);
        });
    },
  },
  mounted() {
    if (
      this.user &&
      this.user.student_card &&
      this.user.group_names.includes("ESTUDIANTES") &&
      this.user.student_card.egress_profile != this.egress_profile_id
    ) {
      this.$router.push({
        name: "Page403",
      });
    }
    if (this.user && this.user.group_names.includes("PROFESORES")) {
      this.$restful
        .Get(`/mesh/fully_visible_professor_egress_profiles/`)
        .then((response) => {
          if (!response.includes(this.egress_profile_id)) {
            this.$router.push({
              name: "Page403",
            });
          }
        });
    }
    this.$store.commit(names.MUTATE_PRINT_ORIENTATION, false);
    this.$store.commit(names.MUTATE_PRINT_ZOOM_SCALE, 1);
  },
  beforeDestroy() {
    this.$store.commit(names.MUTATE_SHOW_INTELLIGENCE_SIDEBAR, false);
    this.$store.commit(names.MUTATE_DELETE_RULES_FILTER_SELECTOR);
    this.$store.commit(names.MUTATE_DELETE_FILTER_INTELLIGENCE);
    this.$store.commit(names.RESET_PRINT_ZOOM_SCALE);
    this.$store.commit(names.RESET_PRINT_ORIENTATION);
    this.$store.commit(names.RESET_TITLE_OF_THE_PRINT);
  },
  created() {
    this.$store
      .dispatch(names.FETCH_EGRESS_PROFILE, this.egress_profile_id)
      .then((egress_profile) => {
        this.$nextTick(() => {
          if (!egress_profile.is_closed && this.can_update)
            this.$store.commit(names.MUTATE_SHOW_INTELLIGENCE_SIDEBAR, true);
          this.$store.commit(names.MUTATE_RULES_FILTER_SELECTOR, {
            visible_intelligence_options: [1, 7],
            disabled_selected_egress_profile: true,
          });
          this.$store.commit(names.MUTATE_FILTER_INTELLIGENCE, {
            egress_profile_id: this.egress_profile_id,
            intelligence_option: 1,
          });
        });
        this.$store.dispatch(names.FETCH_CAREER, egress_profile.career);
        this.$store.commit(
          names.MUTATE_TITLE_OF_THE_PRINT,
          `${this.$getVisibleNames(
            "mesh.egressprofile",
            false,
            "Perfil De Egreso"
          )} ${egress_profile.name}`
        );
      });
    this.$store.dispatch(names.FETCH_EGRESS_PROFILES_MATTERS, {
      egress_profile_id: this.egress_profile_id,
    });
    this.$store.dispatch(names.FETCH_MATTERS, {
      egress_profile_id: this.egress_profile_id,
    });
    this.$store.dispatch(names.FETCH_COURSES_WRAPPER, {
      egress_profile_id: this.egress_profile_id,
    });
  },
};
</script>

<style scoped>
.icon-btn-ai {
  width: 18px;
  height: 18px;
}
::v-deep .btn-ai-custom {
  background-color: var(--kl-fourth-hover-color) !important;
  border-color: var(--kl-fourth-hover-color) !important;
  color: white !important;
}
::v-deep .btn-ai-custom:hover,
::v-deep .btn-ai-custom:focus,
::v-deep .btn-ai-custom:active {
  background-color: var(--kl-fourth-hover-color) !important;
  border-color: var(--kl-fourth-hover-color) !important;
  opacity: 0.9;
}
</style>
